import { Button } from "antd";

export const FormButton = ({ children, type, loading, onClick }) => {
  return (
    <Button
      type={type || "primary"}
      htmlType="submit"
      loading={loading}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
